import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { XCircle, Truck, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center bg-ksy-bg px-5">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-lg bg-white rounded-2xl shadow-xl border border-slate-200 p-8 md:p-10 text-center" data-testid="payment-cancel-page">
        <Link to="/" className="inline-flex items-center gap-2 text-ksy-navy font-display font-extrabold text-xl mb-6">
          <span className="grid place-items-center w-9 h-9 rounded-lg bg-ksy-navy text-white"><Truck className="w-5 h-5" /></span> KS&amp;Y Transport
        </Link>
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
        <h1 className="font-display font-extrabold text-2xl md:text-3xl text-ksy-navy">{t("pay.cancel_title")}</h1>
        <p className="mt-2 text-slate-500">{t("pay.cancel_sub")}</p>
        <Link to="/#book" className="mt-8 inline-flex items-center gap-2 bg-ksy-blue text-white font-bold px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors" data-testid="payment-cancel-home">
          {t("pay.home")} <ArrowRight className="w-4 h-4" />
        </Link>
      </motion.div>
    </div>
  );
}
